import { Box, Typography, withStyles } from "@material-ui/core";
import { COLOR_ARRAY } from "src/config/styleConfig";

const CssTypography = withStyles((theme) => ({
  root: {
    color: theme.palette.text.hint,
  },
}))(Typography);

export default function TitleTypography({ title, textProps, ...props }) {
  return (
    <Box display="flex" alignItems="center" {...props}>
      <CssTypography variant="subtitle2" {...textProps}>
        {title}
      </CssTypography>
    </Box>
  );
}

export const NoteTypography = withStyles(() => ({
  root: {
    fontSize: "12px",
    fontWeight: 400,
  },
}))(Typography);

const BaseTypography = withStyles(() => ({
  root: {
    fontSize: "12px",
    fontWeight: 700,
  },
}))(Typography);

export function FigureTypography({ value, title, index = 0, ...props }) {
  return (
    <BaseTypography {...props} style={{ color: COLOR_ARRAY[index], ...props?.style }}>
      <span style={{ fontSize: "20px", fontWeight: 700, color: COLOR_ARRAY[index] }}>{value}</span>
      &nbsp;{title}
    </BaseTypography>
  );
}
